import CLIENT_ID from './CLIENT_ID'
import CLIENT_SECRET from './CLIENT_SECRET'
import sha256 from './sha256'
import api from 'js/api'
export const loginWithEmail = (email, password) => {
  const timestamp = Date.now()
  return api('POST', 'v2/accounts/authenticate', {
    email: email,
    pass: password,
    timestamp: timestamp,
    api_key: CLIENT_ID,
    hash: sha256(`$${email}$${timestamp}$${CLIENT_SECRET}`),
  }).then(({ response: { token, userid } }) => ({ token, userid }))
}
